import React, { createContext, useEffect } from 'react';
import { observationDraftService } from '../services/observationDraftService';

export interface ObservationDraftScopeValue {
  inspectionId: string;
}

export const ObservationDraftScopeContext =
  createContext<ObservationDraftScopeValue | null>(null);

/**
 * Opts a screen's observation fields into the draft form layer (Phase 2 of #10345).
 * Wrapping a screen is the whole migration: fields inside write to the draft store
 * (instant, remount-safe) and a debounced writer persists all changes in one Dexie
 * transaction. Screens without this provider keep the legacy save-per-field path.
 * Unmounting (route change) flushes any pending changes.
 */
export const ObservationDraftScope = ({
  inspectionId,
  children,
}: {
  inspectionId: string;
  children: React.ReactNode;
}) => {
  useEffect(() => {
    return () => {
      void observationDraftService.flush(inspectionId).then((ok) => {
        if (ok) {
          observationDraftService.release(inspectionId);
        }
      });
    };
  }, [inspectionId]);

  return (
    <ObservationDraftScopeContext.Provider value={{ inspectionId }}>
      {children}
    </ObservationDraftScopeContext.Provider>
  );
};
